module.exports = __webpack_public_path__ + "img/swiper_bg1.34737f18.png";